/**
 * ver 0.1
 * author jack
 * props
 * @props {integer} f_div (required) 찜구분(0 : 정보없음, 1 : 제조사, 2 : 수입원, 3 : 브랜드, 4 : 상품, 11 : 미니샵)
 * @props {integer} idx (required)
 * @props {boolean} loadData true / false
 * @props {boolean} selected true / false
 * ex)
 <Zzim f_div={} idx={} loadData={} selected={} />
 */

import React from 'react'
import ZzimLayer from "./layer/zzimLayer"
import ZzimMobileLayer from "./layer/zzimMobileLayer"


class Zzim extends React.Component {
    constructor(props) {
        super(props)

        let {f_div, idx, loadData, selected, count} = props
        if (selected === undefined) selected = false
        if (loadData === undefined) loadData = false

        this.state = {
            componentUpdate: true,
            f_div, idx, loadData, selected, count,
            zzimLayer:false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.componentUpdate
    }

    componentDidMount() {
        this.setState({componentUpdate: false})
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (this.state.componentUpdate === true){
            this.setState({componentUpdate: false})
        }
    }
    onZzimLayer(selected) {
        let count = this.props.count
        if (this.state.zzimLayer) {
            // console.log(selected);
            // console.log(this.state.zzimLayer);
            if (!this.props.selected && selected) count ++
            else if (this.props.selected && !selected) count --
        }
        this.setState({
            zzimLayer:!this.state.zzimLayer,
            componentUpdate: true,
            selected:selected,
            count:count
        })
    }

    render() {
        const children = this.props.children
        // console.log(children);
        let childrenProps = []

        const isLogin = this.props.isLogin

        if (children !== undefined) {
            if (Array.isArray(children)) {
                childrenProps = children.map(v=>{
                    if (typeof v === 'number') {
                        return this.state.count
                    } else return v
                })
            } else {
                childrenProps = children
            }
        }

        let zzimClass = "icon-favorite zzimBtn"
        if (this.state.selected) zzimClass = "icon-favorite zzimBtn"

        if (this.props.className !== undefined) {
            if (this.state.selected) zzimClass = this.props.classNameOn
            else zzimClass = this.props.className
        }

        let zzimCustomClass = this.state.selected ? 'active' : ''

        let zzimButtonProps = {
            key:0,
            className: this.props.custom ? zzimCustomClass : zzimClass,
            onClick:()=>this.onZzimLayer(this.state.selected),
        }


        let zzimLayerProps = {
            key:1,
            selected: this.state.selected,
            f_div: this.state.f_div,
            idx: this.state.idx,
            onClose:(r)=>this.onZzimLayer(r)
        }

        let zzimLayer = <ZzimLayer {...zzimLayerProps} />
        if (this.props.mobile) {
            zzimLayer = <ZzimMobileLayer {...zzimLayerProps} isLogin={isLogin} />
        }

        let selectCustomStyle = {
            ...this.props.zzimStyle,
            color : '#418DED'
        }

        return [
            this.props.custom
                ? <span {...zzimButtonProps} style={this.props.zzimStyle}>{children}</span>
                : <button {...zzimButtonProps} style={
                    this.state.selected ? selectCustomStyle : this.props.zzimStyle}>{childrenProps}</button>,
            this.state.zzimLayer && zzimLayer
        ]
    }
}

export default Zzim



// WEBPACK FOOTER //
// ./src/common/container/zzim.js